import { flushSync } from "react-dom";
export var flushSyncPlatform = flushSync;
